import React, { useContext } from "react";
import PropTypes from "prop-types";
import styles from "./style/LectureItem.module.css";
import clsx from "clsx";
// import { LECTURE_TYPE } from "@constants";
import { DeleteLectureModal } from "./DeleteLectureModal";
import { LectureFormModal } from "./LectureFormModal";
import { useSelector } from "react-redux";
import { Spinner } from "react-bootstrap";
import { formatTimeHMS } from "@helpers";
import { CurriculumContext } from "@pages/EditingCoursePage/CurriculumTab";

const LectureItem = ({
  lectureInfo,
  id: lectureId,
  isDeleted,
  totalTime,
  sectionId,
  index,
}) => {
  const addprocessingList = useSelector(
    (state) => state.course.addLecture.processingList
  );
  const updateProcessingList = useSelector(
    (state) => state.course.updateLecture.processingList
  );

  const addLectureProcessing = addprocessingList.find(
    (lecture) => lecture.id == lectureId
  );
  const updateLectureProcessing = updateProcessingList.find(
    (lecture) => lecture.id == lectureId
  );

  const { handleDeleteLecture, handleEditLecture } =
    useContext(CurriculumContext);

  return (
    <div
      className={clsx(
        styles.container,
        "py-2 px-3",
        isDeleted ? "d-none" : null
      )}
    >
      <div className="d-flex align-items-center">
        <i className="bi bi-file-earmark-text-fill"></i>

        <span className={clsx("mx-2", styles.title)}>{lectureInfo.title}</span>
        {addLectureProcessing?.processing ||
        updateLectureProcessing?.processing ? (
          <Spinner animation="border" size="sm" variant="danger" />
        ) : null}
        {/* {(addLectureProcessing?.isSuccess == true ||
          updateLectureProcessing?.isSuccess == true) && (
          <i className="bi bi-check-circle-fill text-success"></i>
        )} */}
        {(addLectureProcessing?.isSuccess == false ||
          updateLectureProcessing?.isSuccess == false) && (
          <i className="bi bi-x-circle-fill text-danger"></i>
        )}
        <LectureFormModal
          onSubmit={(newLecture) => handleEditLecture(sectionId, newLecture)}
          initialValues={lectureInfo}
          submitText="Save"
        >
          <button className="ml-2 opacity-0">
            <i className="bi bi-pencil-square"></i>
          </button>
        </LectureFormModal>
        <DeleteLectureModal
          onDelete={() => handleDeleteLecture(sectionId, lectureId)}
        >
          <button className="ml-2 opacity-0">
            <i className="bi bi-trash-fill"></i>
          </button>
        </DeleteLectureModal>
      </div>
      <div>
        <span>{totalTime > 0 && formatTimeHMS(totalTime)}</span>
        <button className="opacity-0">
          <i className="bi bi-list"></i>
        </button>
      </div>
    </div>
  );
};

/* required: display name */
LectureItem.displayName = "LectureItem";

/* required: props types */
LectureItem.propTypes = {
  lectureInfo: PropTypes.any,
  onEdit: PropTypes.func,
  onDelete: PropTypes.func,
};

/* required: default props */
LectureItem.defaultProps = {
  lectureInfo: {},
  onEdit: () => {},
  onDelete: () => {},
};

export { LectureItem };
